export function isAdminViewer() {
  const role = parseInt(localStorage.getItem("role") || "0", 10);
  return (
    role === 7 ||
    localStorage.getItem("isAdmin") === "true" ||
    localStorage.getItem("isAdmin") === "1"
  );
}

export function isAgentOrCsViewer() {
  const role = parseInt(localStorage.getItem("role") || "0", 10);
  return role === 0;
}

/** Has the current user saved a product type on this request before? */
export function currentUserHasSelectedProductType(agent) {
  return agent?.current_user_has_selected_product_type === true;
}

/**
 * @returns {{ items: Array, selectedValue: string|null, forceEmpty: boolean }}
 */
export function resolveProductTypeSelectState(agent, productsList) {
  const items = productsList || [];

  if (isAdminViewer()) {
    return {
      items,
      selectedValue: agent?.req_product_type || null,
      forceEmpty: false,
    };
  }

  if (!isAgentOrCsViewer()) {
    return {
      items,
      selectedValue: agent?.req_product_type || null,
      forceEmpty: false,
    };
  }

  if (currentUserHasSelectedProductType(agent)) {
    return {
      items,
      selectedValue: agent?.req_product_type || null,
      forceEmpty: false,
    };
  }

  return {
    items,
    selectedValue: null,
    forceEmpty: true,
  };
}

export function shouldForceEmptyProductType(requestData) {
  return resolveProductTypeSelectState(requestData).forceEmpty;
}

const PRODUCT_TYPE_PAYLOAD_KEYS = [
  "req_product_type",
  "type_of_selected_product",
  "product_type",
];

/** Clear product type on agent + store when user must choose it themselves. */
export function applyForcedProductTypeClearing(requestData, store = null) {
  if (!requestData || !shouldForceEmptyProductType(requestData)) {
    return false;
  }

  requestData.req_product_type = null;

  if (requestData.funding) {
    requestData.funding.product_code = null;
  }

  const storeRequest = store?.state?.request_info;
  if (storeRequest) {
    if (storeRequest !== requestData) {
      storeRequest.req_product_type = null;
    }
    if (storeRequest.funding) {
      storeRequest.funding.product_code = null;
    }
  }

  return true;
}

/** Remove product type fields from save/send payload so backend validation fires. */
export function stripProductTypeFromUpdatePayload(updatePayload, requestInfo) {
  if (!updatePayload || !shouldForceEmptyProductType(requestInfo)) {
    return updatePayload;
  }

  // User picked req_product_type in this session — keep product fields.
  if (updatePayload.req_product_type) {
    return updatePayload;
  }

  PRODUCT_TYPE_PAYLOAD_KEYS.forEach((key) => {
    delete updatePayload[key];
  });

  return updatePayload;
}

export function buildRequestUpdatePayload(updateRequest, requestInfo) {
  const updatePayload = {};

  for (const prop in updateRequest) {
    if (updateRequest[prop] != null) {
      updatePayload[prop] = updateRequest[prop];
    }
  }

  return stripProductTypeFromUpdatePayload(updatePayload, requestInfo);
}
